import { render } from "./IncomingPage.vue?vue&type=template&id=00438122"
import script from "./IncomingPage.vue?vue&type=script&lang=js"
export * from "./IncomingPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alpha/Documents/IONS/project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__